export default __webpack_public_path__ + "static/media/book_TheBookofZog.901214ed.jpg";